import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import * as productsConstant from './constants'
import * as productsAction from './actions'
import { storedb } from '../client/storedb'
import DisplayRecordText from "../controls/_DisplayRecordText"
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import { confirmAlert } from 'react-confirm-alert';

class Products extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      stores_id: dbContext.getStoreId(),
      item: {},
      list: [],
      IsDeleted: '',
      keyword: '',
      per_page: 20,
      page: 1,
      total_record: 0
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleSelectChange = (name, selectedOption) => {
    switch (name) {
      case "TrangThai":
        this.setState({ IsDeleted: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  ProcessRemoveClick = (res, flag) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn chắc chắn muốn xóa dữ liệu này không?
              </p>
            <button className="text-danger" onClick={() => {
              this.RemoveProductsItem(res, flag)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  RemoveProductsItem = (res, flag) => {
    var requestData = {
      StoreId: this.state.stores_id,
      productsIds: (flag == "allitem" ? res.map(function (item) { return item.ProductId }) : [res.ProductId]),
    }
    return this.props.productsRemoveRequest(requestData);
  }
  fetchList = (page) => {
    const { productsListRequest } = this.props
    const requestData = this.getParamsForRequest(false, page)
    return productsListRequest(requestData);
  }
  getParamsForRequest = (isExport, page) => {
    var requestData = {
      stores_id: this.state.stores_id,
      keyword: this.state.keyword,
      status: this.state.IsDeleted
    };
    if (!isExport) {
      requestData["page"] = page || this.state.page
      requestData["per_page"] = this.state.per_page
    }
    return requestData
  }
  search = () => {
    if (this.props.products.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => this.fetchList(1));
  }
  exportXls = () => {
    const { productsExportXlsRequest } = this.props
    var requestData = this.getParamsForRequest(true, null)
    return productsExportXlsRequest(requestData, (listExp) => {
      var dataFile = new Blob([listExp], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExport';
      var fileName = "ds_san_pham.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExport";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
      }
    });
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.search()
    }
  }
  refresh = () => {
    this.setState({
      stores_id: this.state.stores_id,
      keyword: '',
      IsDeleted: '',
      page: this.state.page,
      per_page: this.state.per_page
    }, () => {
      if (this.props.products.listRequesting) {
        return false;
      }
      return this.fetchList()
    })
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  EditproductsItem = (item, e) => {
    this.props.history.push('/products-edit?pid=' + (item.ProductId || ""));
  }
  viewProductsItem = (e, productId) => {
    e.preventDefault()
    this.props.history.push('/products-edit?pid=' + (productId || ""));
  }
  componentDidMount() {
    this.fetchList();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.products.type == productsConstant.PRODUCTS_LIST_SUCCESS) {

      let { list, item } = nextProps.products;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: list
      });
    } else if (nextProps.products.type == productsConstant.PRODUCTS_REMOVE_SUCCESS) {
      this.fetchList()
    }
  }
  render() {
    const {
      handleSubmit,
      products: {
        isRequesting,
        listRequesting,
        errors,
        messages,
        list
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." open={true}>
              <Row>
                <Col sm="8" className="mb-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off" >Thông tin sản phẩm</InputGroupAddon>
                    <Input name="keyword" placeholder="Tìm theo tên hoặc mã thuốc, mã vạch"
                      value={this.state.keyword}
                      onChange={this.handleSearchChange.bind(this, "keyword")}
                      onKeyDown={e => this.keyPress(e)}
                      autoComplete="off" />
                  </InputGroup>
                </Col>
                <Col sm="4" className="mb-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend">Trạng thái</InputGroupAddon>
                    <select className="form-control" value={this.state.IsDeleted} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                      <option value="">Trạng thái</option>
                      <option value={0}>Hoạt động</option>
                      <option value={1}>Ngừng hoạt động</option>
                    </select>
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="pull-left mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Tìm kiếm</Button>
              <Button size="md" color="success" className="pull-left mr-1" onClick={() => this.exportXls({})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
              <ButtonExt className="mr-1"
                color="primary"
                iconClass="fa-plus"
                displayText="Thêm mới"
                btnClick={() => this.EditproductsItem({})}
                permission={BtnPermissions.SanPham.ADD_OR_UPDATE} />
            </div>
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" width="100" className="text-left">Mã thuốc</th>
                    <th scope="col" width="100" className="text-left">Mã vạch</th>
                    <th scope="col" className="text-left">Tên sản phẩm</th>
                    <th scope="col" className="text-left">Nhóm hàng</th>
                    <th scope="col" width="150" className="text-left">Quy cách đóng gói</th>
                    <th scope="col" width="70" className="text-center">ĐVT</th>
                    <th scope="col" width="70" className="text-right">Giá nhập</th>
                    {/* <th scope="col" className="text-left">Giá lẻ</th> */}
                    <th scope="col" width="60" className="text-center">Điểm</th>
                    <th scope="col" width="80" className="text-center">Trạng thái</th>
                    <th scope="col" width="50" className="text-center">
                      <ButtonExt
                        btnClass="text-danger"
                        iconClass="fa-trash fa-lg"
                        btnType={BtnType.ButtonLink}
                        btnClick={() => this.ProcessRemoveClick(list, "allitem")}
                        permission={BtnPermissions.SanPham.ADD_OR_UPDATE} />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left"><a href='#' onClick={(e) => this.viewProductsItem(e, res.ProductId)}> {res.Sku}</a> </td>
                        <td className="text-left">{res.BarCode}</td>
                        <td className="text-left"><a href='#' onClick={(e) => this.viewProductsItem(e, res.ProductId)}> {res.Ten}</a> </td>
                        <td className="text-left">{res.NganhHang}</td>
                        <td className="text-left">{res.QuyCachDongGoi}</td>
                        {/* <td className="text-left">{parseFloat(res.QuyCach || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td> */}
                        <td className="text-center">{res.DvtTen}</td>
                        <td className="text-right">{parseFloat(res.GiaNhap || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        {/* <td className="text-left">{parseFloat(res.GiaBanLe || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td> */}
                        <td className="text-right">{parseFloat(res.Diem || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-center">
                          {res.IsDeleted == 1 ? <span className="text-danger"><i className="fa fa-close"></i></span> : <span className="text-success"><i className="fa fa-check"></i></span>}
                        </td>
                        <td scope="row" className="text-center">
                          <ButtonExt
                            btnClass="text-danger"
                            iconClass="fa-trash fa-lg"
                            btnType={BtnType.ButtonLink}
                            btnClick={() => this.ProcessRemoveClick(res, "item")}
                            permission={BtnPermissions.SanPham.ADD_OR_UPDATE} />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="11">
                      <span className="text-success mr-2"><i className="fa fa-check"></i> = Đang hoạt động</span>
                      <span className="text-danger"><i className="fa fa-close"></i> = Dừng hoạt động</span>
                    </td>
                  </tr>
                </tfoot>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
        <Row>
          <Col md="12">
            {!isRequesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!isRequesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  products: state.products,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  productsListRequest: productsAction.productsListRequest,
  productsUpdateRequest: productsAction.productsUpdateRequest,
  productsRemoveRequest: productsAction.productsRemoveRequest,
  productsExportXlsRequest: productsAction.productsExportXlsRequest
})(Products)
const formed = reduxForm({
  form: 'products',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/Products/Products.js